import { AxiosResponse } from "axios"

export function extractData<T extends { body: T["body"] }>(
  res: AxiosResponse<T>
) {
  return res.data?.body
}
